import React from "react";
import MainSecFourMobile from "./MainSecFourMobile";
import Footer from "../../modules/Footer/Footer";

export default function MainSecFour() {
  return (
    <div className=" w-full h-full  flex flex-col items-center justify-between ">
      <div
        dir="rtl"
        className="w-full  max-w-[1440px] hidden min-[769px]:flex items-center justify-between mt-[10vh]"
      >
        <div className="w-1/2 flex flex-col items-center justify-center">
          <div className="w-[556px]  flex items-start justify-center gap-x-[8px]">
            <span className="font-font_primary_A font-bold text-[38px] text-color-primary-B">
              نوین
            </span>
            <span className="font-font_primary_A font-bold text-[38px] text-color-primary-C">
              در راه خدمت رسانی
            </span>
          </div>
          <div className="w-[580px]  flex flex-col items-center justify-end mt-[40px] ">
            <span className="font-font_primary_A  text-[16px] text-justify text-color-primary-D">
              اپلیکیشن اسکارپین با بهره گیری از هوش مصنوعی تمام پارامترهای مصرفی
              خودرو شما را تحت نظارت دارد؛ به گونه ای که هر پارامتر مصرفی خودرو
              قبل از رسیدن به شرایط بحرانی به شما اطلاع داده می شود.
            </span>
          </div>
          <div className="w-[450px]  flex items-center justify-center gap-x-[60px] mt-[60px] ">
            <button
              className="cursor-pointer"
              onClick={() => {
                window.open("https://scarpin.ir/l/SBAZ", "_blank");
              }}
            >
              <img
                src="../assets/images/other/cafe_bazar.svg"
                className="w-[150px] h-[50px] "
              />
            </button>
            <button
              className="cursor-pointer"
              onClick={() => {
                window.open("https://scarpin.ir/l/SWEB", "_blank");
              }}
            >
              <img
                src="../assets/images/other/pwa.svg"
                className="w-[150px] h-[50px] "
              />
            </button>
          </div>
        </div>
        <div className="w-1/2 flex items-center justify-center">
          <div className="relative w-[441.5px] h-[51vh] ">
            <img
              src="../assets/images/other/phone1.png"
              className="absolute w-[242px] h-[45.5vh] max-h-[485px] right-0 top-[-1vh] z-10"
            />
            <img
              src="../assets/images/other/phone2.png"
              className="absolute w-[242px] h-[45.5vh] max-h-[465px] left-[35px] bottom-0 "
            />
          </div>
        </div>
      </div>
      <Footer />

      <MainSecFourMobile />
    </div>
  );
}
